import validator from 'validator';
import {
  fieldIsType,
  getFieldValidators,
  getFieldValue,
  getFieldProperties,
  getFieldPropertyValues,
  getMapFromArray,
  Messages,
} from './components/form-field-types/helpers';
import { MobileConsentValidationMessage } from './components/form-field-types/form-field-mobile-consent';

export const validateField = (field, requiredOverride = false) => {
  const makeRequired = requiredOverride || isRequired(field);
  const value = getFieldValue(field);
  const validators = getFieldValidators(field);
  const properties = getFieldProperties(field, 'specific');
  let errors = [];

  if (makeRequired) {
    const validationError = validateIsBlank(field, value);
    if (validationError) errors.push(validationError);
  }

  // only run validations if we either have a value or it is a required field
  // e.g., a blank value shouldn't fail validation unless the field is required
  if (value && errors.length === 0) {
    validators.forEach((validation) => {
      const result = validation.fn(value, { properties });
      if (result && !result.valid) errors.push(result.message);
    });
  }

  if (errors.length > 0) {
    return [`${field.display_name || field.type_name} ${errors[0]}`];
  }
};

export const validateMobileConsentField = (input, fields) => {
  const value = getFieldValue(input);
  if (!value) {
    // any phone fields that are required or have a value will trigger validation
    const requiredPhone = Object.entries(fields).find(([_key, field]) => {
      if(field.display_name === 'Phone Number' && field.properties.common) {
        const propMap = getMapFromArray(field.properties.common);
        const { value } = propMap.get('makeRequired');
        return value || field.value;
      }
    });
    if (requiredPhone) {
      return MobileConsentValidationMessage;
    }
  }
};

const isRequired = (field) => {
  return getFieldPropertyValues(
    getFieldProperties(field, 'common').common,
    'makeRequired'
  ).makeRequired;
};

const validateIsBlank = (field, value) => {

  if (field.type_name === 'Multiple Choice' && value && noneTrue(value))
    return Messages.ONE_CHECKED;

  const uuidNameArray = [
    '351ee6a1-2e06-466b-9e5a-9789bea31d6d', // Request an Appointment
    '0bfa90c5-caaa-4553-b2b6-b115b37cf259', // communication release
    '201491cd-8d5f-4448-a211-6e5bae0cbfbc', // authorization and acknowledgements
    '342ca295-40e9-4c5a-8cc7-898ca0cbbb04', // insurance_info
    '7083bb57-28aa-4ee0-b81a-bdb700f539e7', // dental_history
    '8271260b-ddf1-4d3a-9f55-e3fe71a352fb', // patient_history
    '8d226da1-2162-4aad-aa74-07e38d016cd0', // medical history
  ];

  if (uuidNameArray.includes(field.uuid)) {
    if (
      validator.isEmpty(field.value[0], { ignore_whitespace: true })
      && validator.isEmpty(field.value[2], { ignore_whitespace: true })
    ) {
      return Messages.CANT_BE_BLANK;
    }
  }

  if (
    // value = 0 (aka, falsey) is valid for Sliding Scale component
    (!value && !fieldIsType(field, 'Sliding Scale')) ||
    validator.isEmpty(value.toString(), { ignore_whitespace: true })
  )
    return Messages.CANT_BE_BLANK;
};

// custom validator for checkbox groups (multiple choice)
// that enforces at least one option should be checked (true), if required.
const noneTrue = (values) =>
  values.filter((value) => Object.values(value)[0]).length === 0;
